module.exports = __webpack_public_path__ + "img/Group_217.59a835de.png";